<template>
  <div class="mb-container" :style="themeVariables">
    <div :class="`mb-result-text ${getStatus(resultData.isAllPass)}`">
      <div class="mb-result-icon"></div>
      <div>
        <p>{{resultData.isAllPass ? '设备检测通过' : '设备检测不通过'}}</p>
        <p>{{resultData.isAllPass ? '可以开始正常考试' : '可能无法正常考试'}}</p>
      </div>
    </div>
    <div class="mb-device-box">
      <div class="mb-device-title">
        <div class="mb-device-left">
          <span class="mb-title-icon"></span>
          <span class="mb-title">网络与设备</span>
        </div>
        <span :class="`mb-status-icon ${getStatus(resultData.device_net)}`"></span>
      </div>
      <div class="mb-device-content">
        <p>
          <span class="mb-label">CPU</span>
          <span class="mb-text">{{ resultData.cpu }}</span>
        </p>
        <p>
          <span class="mb-label">内存</span>
          <span class="mb-text">{{ resultData.memory }}</span>
        </p>
        <p>
          <span class="mb-label">系统版本</span>
          <span class="mb-text">{{ resultData.os_version }}</span>
        </p>
        <p>
          <span class="mb-label">网络</span>
          <span class="mb-text">{{ resultData.device_net_text }}</span>
        </p>
      </div>
    </div>
    <div class="mb-device-box mb-camera-box">
      <div class="mb-device-title">
        <div class="mb-device-left">
          <span class="mb-title-icon"></span>
          <span class="mb-title">摄像头</span>
        </div>
        <span :class="`mb-status-icon ${getStatus(resultData.videoAuth)}`"></span>
      </div>
    </div>
    <div class="mb-device-box mb-micro-box">
      <div class="mb-device-title">
        <div class="mb-device-left">
          <span class="mb-title-icon"></span>
          <span class="mb-title">麦克风</span>
        </div>
        <span :class="`mb-status-icon ${getStatus(resultData.micAuth)}`"></span>
      </div>
    </div>
    <div class="mb-footer">
      <button
        v-show="isAllPass"
        class="mb-button mb-primaray"
        @click="goPretestPage"
      >确定</button>
      <button
        v-show="!isAllPass"
        class="mb-button mb-mr-12"
        @click="isShowModal = true"
      >
        继续考试
      </button>
      <button
        v-show="!isAllPass"
        class="mb-button mb-primaray"
        @click="restartDetect"
      >重新检测</button>
    </div>
    <MbModal
      title="提示"
      :show.sync="isShowModal"
    >
      <p slot="content">你的设备检测未通过，若因设备检测未通过而影响到正常考试，由考生自行承担后果，是否进入考试？</p>
      <div slot="footer" class="mb-modal-footer">
        <button
          class="mb-button mb-width-252 mb-mr-12"
          @click="goPretestPage"
        >继续考试</button>
        <button
          class="mb-button mb-primaray mb-width-252"
          @click="isShowModal = false"
        >取消</button>
      </div>
    </MbModal>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { post } from '@/utils/ajax'
import MbModal from '@/components/MbModal'

export default {
  props: {
    resultData: Object
  },
  components: {
    MbModal
  },
  computed: {
    ...mapState(['testConfig', 'user']),
    themeVariables() {
      const theme = this.$store.state.theme || {}
      const normalize = value => String(value || '').replace(/;+\s*$/, '')
      const color = normalize(theme.themeColor) || '#3d81ff'
      return {
        '--mobile-theme': color,
        '--mobile-button-background': normalize(theme.buttonBackground) || color,
        '--mobile-button-shadow': normalize(theme.buttonShadow) || 'none'
      }
    },
    testInfo() {
      return this.$store.state.testInfo
    },
    getStatus() {
      return (status) => {
        return status ? 'success' : 'fail'
      }
    },
    isAllPass() {
      return this.resultData.isAllPass
    }
  },
  data() {
    return {
      btnLoading: false,
      isShowModal: false
    }
  },
  methods: {
    goPretestPage() {
      this.$router.push({ name: 'pretest' })
    },
    // 跳转考试
    async goTestPage () {
      this.btnLoading = true
      await post(`/home/edu/examinees/start/${this.testInfo.exam_id}/${this.testInfo.examinee_id}`)
      localStorage.setItem('user_id', this.user.id)
      this.$router.push({ name: 'test' })
      this.btnLoading = false
    },
    restartDetect() {
      this.$emit('restartDetect')
    }
  }
}
</script>
<style lang="scss" scoped>
@import './resultPage.scss';
</style>
